var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Create a new chat session
 */
export var createChatSession = function (apiBaseURL, authToken, toolPackId, registeredUserId, additional_system_prompt) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(apiBaseURL, "/api/chat/sessions/"), {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Token ".concat(authToken),
                        },
                        body: JSON.stringify(__assign({ tool_pack: toolPackId, registered_user: registeredUserId }, (additional_system_prompt && { additional_system_prompt: additional_system_prompt }))),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Failed to create chat session");
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                console.error("Error creating chat session:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Fetch list of tool packs from the backend
 */
export var fetchToolPacks = function (apiBaseURL, authToken, search) { return __awaiter(void 0, void 0, Promise, function () {
    var params, queryString, url, response, data, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                params = new URLSearchParams();
                if (search)
                    params.set("search", search);
                queryString = params.toString();
                url = "".concat(apiBaseURL, "/api/tool-packs/").concat(queryString ? "?".concat(queryString) : "");
                return [4 /*yield*/, fetch(url, {
                        headers: {
                            Authorization: "Token ".concat(authToken),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Failed to fetch tool packs");
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data.results];
            case 3:
                error_2 = _a.sent();
                console.error("Error fetching tool packs:", error_2);
                throw error_2;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Fetch list of test registered users from the backend
 */
export var fetchRegisteredUsers = function (apiBaseURL, authToken, search) { return __awaiter(void 0, void 0, Promise, function () {
    var params, response, data, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                params = new URLSearchParams({ is_test_user: "true" });
                if (search)
                    params.set("search", search);
                return [4 /*yield*/, fetch("".concat(apiBaseURL, "/api/registered-users/?").concat(params.toString()), {
                        headers: {
                            Authorization: "Token ".concat(authToken),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Failed to fetch registered users");
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data.results];
            case 3:
                error_3 = _a.sent();
                console.error("Error fetching registered users:", error_3);
                throw error_3;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Fetch list of connectors from the backend
 */
export var fetchConnectors = function (apiBaseURL, authToken) { return __awaiter(void 0, void 0, Promise, function () {
    var response, data, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(apiBaseURL, "/api/connectors/"), {
                        headers: {
                            Authorization: "Token ".concat(authToken),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Failed to fetch connectors");
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data.results];
            case 3:
                error_4 = _a.sent();
                console.error("Error fetching connectors:", error_4);
                throw error_4;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Fetch prompt suggestions for a tool pack
 */
export var fetchPromptSuggestions = function (apiBaseURL, authToken, toolPackId) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(apiBaseURL, "/api/tool-packs/").concat(toolPackId, "/prompt-suggestions"), {
                        headers: {
                            Authorization: "Token ".concat(authToken),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Failed to fetch prompt suggestions");
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_5 = _a.sent();
                console.error("Error fetching prompt suggestions:", error_5);
                throw error_5;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Fetch current user's preferences
 */
export var fetchMeUser = function (apiBaseURL, authToken) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(apiBaseURL, "/api/users/me/"), {
                        headers: {
                            Authorization: "Token ".concat(authToken),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Failed to fetch user preferences");
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_6 = _a.sent();
                console.error("Error fetching user preferences:", error_6);
                throw error_6;
            case 4: return [2 /*return*/];
        }
    });
}); };
